<template>
  <div class="inputShell temr">
    <div class="inputBox">
      <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
      <div class="inputItem">
        <input
          class="inputContainer"
          :disabled="params.disabled"
          :placeholder="params.props.placeholder"
          :maxLength="params.props.maxLength"
          @input="changeInput"
          v-model="value"
          type="text"
        />
        <div class="error" :style="{ color: 'red' }" v-if="error">{{ error }}</div>
      </div>
    </div>
    <van-icon  v-if="!params.disabled && allowClearHandler && value" @click="allowClear" class="cross" name="cross" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'Input',
  data() {
    return {
      value: '',
      error: '',
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    getInvitedCodeFromProductId(productId) {
      this.$api.CommonForms.getInvitedCodeFromProductId({
        productId
      }).then((res) => {
        if (res && res.data) {
          this.referrer = res.data.inviteCode || '';
          this.support = !res.data.support;
        }
      });
    },
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      this.value = val.target.value;
    },
  },
  watch: {
    // // 监听store里productId
    // 'publicPage.submitInfoAll.productId': {
    //   handler(val,oldVal) {
    //     if(!oldVal&&oldVal!==val){
    //       this.getInvitedCodeFromProductId(val);
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  flex: 1;
}
>>> input:disabled {
  background: #fff;
}
.allowClear {
  font-size: 14px;
  color: #999;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -15px;
    }
  }
}
.error {
  font-size: 12px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
.inputShell >>> input::-webkit-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}
.inputShell >>> input::-moz-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}
.inputShell >>> input::-ms-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}

.title {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #46494D;
  line-height: 21px;
  font-weight: 400;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  width: 70px;
  margin-right: 16px;
}
.cross {
  color: #9e9fa0;
}
</style>
